/**
 * Trims leading/trailing whitespace and removes carriage returns and newlines.
 * Use for first_name, last_name, email and similar fields to avoid paste-induced characters.
 */
export function trimField(value: string): string {
  if (value == null || typeof value !== 'string') return value;
  return value.replace(/\r|\n/g, '').trim();
}
